<template>
    <v-container fluid>
      <v-card>
        <v-fab-transition>
          <v-btn
            v-show="true"
            color="green"
            fab
            dark
            absolute
            top
            right
            @click.stop="openCategoryDialog()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-card-title>
          Categories
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="$store.state.categories"
          :search="search"
          :sort-by.sync="sortby"
          :loading="$store.state.categories.length > 0 ? false : true"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.actions="{ item }">
            <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
      
                  
                  <v-list>
                    <v-list-item
                      @click.stop="openCategoryDialog(item)"
                    >
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click.stop="openDeletingDialog(item)"
                    >
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
          </template>
           <div slot='item.name' slot-scope='{ item }' v-html='item.name' />

          <template v-slot:item.stallholder_type="{ item }">
            <v-tooltip bottom  v-if="item.stallholder_type">
              <template v-slot:activator="{ on }">
                <v-chip  v-on="on" :color="getStallholderColor(item.stallholder_type)" dark>{{ item.stallholder_type.charAt(0).toUpperCase() }}</v-chip>
              </template>
              <span>{{ item.stallholder_type }}</span>
            </v-tooltip>
          </template>
           <template v-slot:item.stallholder="{ item }">
            <span v-if="item.booking && item.booking.stallholder_id">{{ item.booking.post_title}}</span>
            <span v-else-if="item.default_stallholder && item.default_stallholder.stallholder_id"
              class="grey--text font-italic"
              >Default: {{ item.default_stallholder.stallholder_id }}</span>
          </template>
        </v-data-table>
      </v-card>
          <v-dialog v-model="isCategoryDialogVisible" persistent max-width="700">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.stop="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Stallholder Category</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>

          </v-toolbar-items>
        </v-toolbar>
        <v-alert
          v-model="alert.show"
          :dismissible="alert.dismissible"
          :type="alert.type"
          transition="fade-transition"
          class="ma-4"
        >
          {{ alert.text }}
        </v-alert>
        <v-form
          ref="form"
          v-model="form"
          class="pa-4 pt-6"
        >
          <v-text-field
            v-model="categoryFormData.name"
            filled
            label="Name"
            :rules="[rules.required, rules.maxLength(100, categoryFormData.name)]"
          ></v-text-field>
          <v-textarea
            v-model="categoryFormData.description"
            auto-grow
            filled
            label="Description"
            rows="3"
            counter="125"
            :rules="[rules.maxLength(125, categoryFormData.description)]"
          ></v-textarea>

          <v-select
            v-model="categoryFormData.categories_disallowed"
            :items="this.$store.state.categories"
            item-text="name"
            item-value="id"
            chips
            hint="ie. Categories that cannot be booked in rule affected stalls of a booked stall with this category"
            persistent-hint
            label="Disallowed Categories"
            multiple
          ></v-select>
          
          <uploads-grid
            :images="categoryImages" lg="4" md ="4" sm= "6" xs="12"
            v-on:delete:image="deleteImage($event)"
          />

          <v-file-input chips multiple label="Upload Image"
            v-model="files"
            accept="image/*" 
            @change="onFileChange"
          ></v-file-input>

        </v-form>
         <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary darken-1"
            text
            @click.stop="submitForm()"
            :disabled="savingDialog"
            :loading="savingDialog"
          >
            {{ formAction }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deletingDialog.show"
      max-width="300"
      persistent
    >
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>

        <v-card-text v-html="deletingDialog.text"></v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary darken-1"
            text
            @click="closeDeletingDialog()"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary darken-1"
            text
            @click="deleteCategory(deletingDialog.item.id)"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="savingDialog"
        persistent
        width="150"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text class="pt-5">
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>

</template>
<script>

import axios from 'axios';
import { mapGetters } from 'vuex'
import UploadsGrid from '../components/UploadsGrid.vue'

export default {
  data() {
    return {
      search: '',
      datemenu: false,
      isCategoryDialogVisible: false,
      categoryFormData: {
        id: 0,
        name: ''
      },
      initialCategoryFormData: null,
      headers: [
        { text: 'Category Name', value: 'name' },
        { text: '', value: 'actions', sortable: false, align: 'right'}
      ],
      sortby: 'name',
      actions: [
        { title: 'Edit' }
      ],
      form: false,
      data : [],
      isDataLoading: false,
      savingDialog: false,
      deletingDialog: {
        show: false,
        text: '',
        item: null
      },
      rules: {
        lengthOLD: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
        password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
          'Password must contain an upper case letter, a numeric character, and a special character',
        required: v => !!v || 'This field is required',
        email: v =>  /.+@.+/.test(v) || 'Please enter a valid email',
        maxLength: (len, v) => (v || '').length <= len || `Invalid character length, maximum ${len}`

      },
      alert: {
        show: false,
        text: '',
        type: 'success',
        dismissible: true,
      },
      confirmDialog: {
        show: false,
        text: '',
      },
      formAction: "create",
      files: null,
      filesToUpload: [],
      filesToDelete: [],
    }
  },
  components: {
    UploadsGrid
  },
  watch: {
    categoryFormData: {
      handler: function (val, oldVal) { 
        console.log('change data');
        // if(this.alert.show)
        //   this.resetAlert();
      },
      deep: true
    },
  },
  methods: {
    openCategoryDialog (item=false) { 
      this.isCategoryDialogVisible = true
      if(item) {
        this.categoryFormData = Object.assign({}, item);
        this.formAction = 'update';
      }
    },
    closeDialog(){
      this.isCategoryDialogVisible = false;
      this.filesToDelete = [];
      this.filesToUpload = [];

      // wait half a sec, before resetting data (otherwise we see it cleared before the dialog fully transitions)
      setTimeout(() => {
        this.resetForm(); 
        this.categoryFormData = Object.assign({}, this.initialCategoryFormData);
        this.resetAlert();
      }, 500)
    
    },
    resetForm() {
      this.$refs.form.reset()
      this.formAction = 'create'; //reset to default
    },
    submitForm() {
      this.resetAlert();
      console.log('hello');
      console.warn(this.$refs.form);
      if(this.$refs.form.validate()) {
        this.updateCategory();
      } else{
         console.log("non validate")
      }
    },
    openDeletingDialog (item) { 
      this.deletingDialog.show = true;
      this.deletingDialog.text = `Permanently delete the category<strong> ${item.name}</strong>?`
      this.deletingDialog.item = item;
    },
    closeDeletingDialog(){
      this.deletingDialog.show = false;
      this.deletingDialog.text = ""
      this.deletingDialog.item = null;
    },
    deleteCategory(id){
        console.log("to delete jere"+id);
        this.savingDialog = true;
        let self = this;  

      axios({
            method: 'DELETE',
            url: `/wisdom-markets/v1/categories/${id}`,
            headers: {
               'Authorization': `Bearer ${this.$store.state.accessToken}`,
            }, 
        })
        .then(response => {
            console.log("deleted", response);

            //this.closeDialog();
            this.savingDialog = false;
            this.closeDeletingDialog();

            //self.showAlert('success', 'Saved!');

            if(response.data == true) {
              console.log("deleting"+id)

              this.$store.commit('deleteCategory', id);
            }
        })
        .catch(function (error) {
            console.log("error deleting", error);
            //todo display error popup
            self.savingDialog = false;
        });

    },
    updateCategory(){
      this.savingDialog = true;
      console.log("need to update DB here")
      let self = this;
      
      // setTimeout(function(){
      //   self.savingDialog = false;
      //   //self.confirmationDialog = true;

      //   self.showAlert('success', 'Saved!', 'my heading');
      //   //self.closeDialog();
      // }, 3000)
      let isUpdatingId = ''

      if(this.categoryFormData.id!==0)
        isUpdatingId=this.categoryFormData.id;

      let fdata = new FormData();

      for ( const key in this.categoryFormData ) {
        if(key == 'category_image') continue;

        if(Array.isArray(this.categoryFormData[key])){
          this.categoryFormData[key].forEach( value=>{
            fdata.append(`${key}[]`, value);
          })
        }else{ // we don't POST profile_images only, profile_images_to_upload, category_images_to_delete
          fdata.append(key, this.categoryFormData[key]);
        }
      }

      for(var i=0, len=this.filesToUpload.length; i<len; i++) {
        fdata.append('category_image_to_upload[]', this.filesToUpload[i]); 
      }

      for(var i=0, len=this.filesToDelete.length; i<len; i++) {
        fdata.append('category_images_to_delete[]', this.filesToDelete[i]); 
      }

      axios({
            method: 'POST',
            url: `/wisdom-markets/v1/categories/${isUpdatingId}`,
            headers: {
               'Authorization': `Bearer ${this.$store.state.accessToken}`,
               //'Content-Type': 'multipart/form-data'
            }, 
            data: fdata
        })
        .then(response => {
            console.log("saved", response);
            console.warn(response);

            //this.closeDialog();
            this.savingDialog = false;
            self.showAlert('success', 'Saved!');

            if(response.data.id && self.formAction == 'create') {
              console.log("adddding", response.data.id)
              this.$store.commit('addCategory', response.data);
              this.categoryFormData.id = response.data.id;
              this.formAction = 'update';
            }else{
              this.$store.commit('updateCategory', response.data);
            }

            this.categoryFormData.category_image = response.data.category_image;
            this.files = [];
            this.filesToUpload = [];
            this.filesToDelete = [];
        })
        .catch(function (error) {
            console.log("error saving", error);
            //todo display error popup
            // this.isSaveBtnLoading = false;
            // this.isCloseBtnDisabled = false;
            self.savingDialog = false;
            self.showAlert('error', 'Error!');
        });

    },
    showAlert(type, text){
      console.log("IN alert fiunction", type, text);
      this.alert.show = true;
      this.alert.text = text
      this.alert.type = type;
      // let self = this;

      // setTimeout(function(){
      //   self.resetAlert();
      // }, 4000)
    },
    resetAlert() { //and reset
      this.alert = {
        show: false,
        text: '',
        type: 'info',
        dismissible: true,
      }
    },
    onFileChange() {
      console.log("FILE CHANGE");

      if(this.files){
        this.files.forEach((f, index) =>{          
          console.log("select file type ="+f.type);
          console.log(f);
          if(!f.type.match("image.*") &&  !f.type.match(".*pdf") && !f.type.match("audio.*") && !f.type.match(".*wordprocessing")) {
              alert('Incorrect file format selected');
              return;
          }
          if(f.size>10485760) {
              alert('Maximum file size is 10mb');
              return;
          }

          this.filesToUpload.push(f);
        });
      }
    },
    deleteImage(image) {
      console.log("imf");
      console.error(image);
      this.filesToDelete.push(image.id);
    }
  },
  computed: {
     categoryImages(){

      let data;

      if(this.categoryFormData.category_image) {
        data = this.categoryFormData.category_image.filter(item => {
            return !this.filesToDelete.some( deleteId => { return item.id == deleteId });
        });
      }

      return data;
    },
  },
  mounted(){
    console.log('mount')
    this.$store.dispatch('getStallholderCategories', { });
    this.initialCategoryFormData = Object.assign({}, this.categoryFormData); 
  }
}
</script>

<style>

</style>